// api/pettyCashTransactionsApi.js
import apiClient from "./axios";

// Get all transactions (paginated)
export const getPettyCashTransactions = async (params = {}) => {
  const { data } = await apiClient.get("/petty-cash/transactions", { params });
  return data;
};

// Get a single transaction
export const getPettyCashTransaction = async id => {
  const { data } = await apiClient.get(`/petty-cash/transactions/${id}`);
  return data;
};

// Create a transaction
export const createPettyCashTransaction = async transactionData => {
  const { data } = await apiClient.post("/petty-cash/transactions", transactionData);
  return data;
};

// Edit a transaction
export const editPettyCashTransaction = async ({ id, ...transactionData }) => {
  const { data } = await apiClient.patch(`/petty-cash/transactions/${id}`, transactionData);
  return data;
};

// Delete a transaction
export const deletePettyCashTransaction = async id => {
  const { data } = await apiClient.delete(`/petty-cash/transactions/${id}`);
  return data;
};

// Get all transactions without pagination
export const getAllPettyCashTransactions = async (params = {}) => {
  const { data } = await apiClient.get("/petty-cash/transactions", {
    params: { ...params, all: true },
  });
  return data;
};

// Get trashed transactions
export const getTrashedPettyCashTransactions = async (params = {}) => {
  const { data } = await apiClient.get("/petty-cash/transactions/trashed", { params });
  return data;
};

// Restore a trashed transaction
export const restorePettyCashTransaction = async id => {
  const { data } = await apiClient.post(`/petty-cash/transactions/${id}/restore`);
  return data;
};